import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { MatSnackBar, MatDialog } from '@angular/material';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Option } from '../../shared/model/model.class';
import { Lead, LeadForm } from '../model/model.lead';
import { LeadService } from '../lead.service';
import { MapleadfeldComponent } from '../mapleadfeld/mapleadfeld.component';
import { LeadsUpload } from '../../app-routing.module';
import { SingleleadComponent } from '../singlelead/singlelead.component';

@Component({
  selector: 'app-listlead',
  templateUrl: './listlead.component.html',
  styleUrls: ['./listlead.component.css']
})

export class ListleadComponent extends AppComponentClass<Lead, LeadForm>
{
  dialerlist: any[]= JSON.parse(sessionStorage.getItem("allcampaign"));
 /*  isD1: boolean
  isD2: boolean
  isD3: boolean */
  udL: boolean
  /* sRd1: number = 2;
  d1Ttl: string = ""
  d2Ttl: string = ""
  d3Ttl: string = "" */
  sRd: string = "2"
  r1: boolean
  r2: boolean

/*   phonescript: any[] = [
    { name: 'Script1' },
    { name: 'Script2' },
    { name: 'Script3' }
  ];
  leadtype: any[] = [
    { name: 'Leadtype1' },
    { name: 'Leadtype2' },
    { name: 'Leadtype3' }
  ];
  assignld: any[] = [
    { name: 'Agent1' },
    { name: 'Agent2' },
    { name: 'Agent3' }
  ]; */

  subadmin: boolean;
  admin: boolean;
  foundregion: boolean;
  region: Option[];
  baldata: any;
  keydata: number;
  modelcl: any;
  dataSource: any;
  form: FormGroup;
  public LeadsUpload = LeadsUpload;
  campainType: Option[];
  leadList = [];
  leadagentList: Option[];
  public fileheader: any;
  public keytype: number;
  public leadinsertid: number;
  leadstate: boolean = false;
  leadFields: any
  public leadopt: number = 2
  public uploadtype: boolean = false;
  public mappedheader = [];
  public stateList = [];
  public ddnumber: boolean = false;

  /* leadListCamp1 = [];
  leadListCamp2 = [];
  leadListCamp3 = []; */
  finalDt: any = {}
  finalDtSn: any = {
    leadFields: ""
  }
  campaignsIds: any[] = [sessionStorage.getItem("currcampaign")]
  isSave: boolean = false
  isUpload: boolean = false

  Dialers: any[] = []
  CampIds: any = sessionStorage.getItem("currcampaign");
  DialerScripts: any[] = []
  DialerAgents: any[] = []
  ActDialers: any[] = []
  isC: boolean = false
  chkD: boolean
  rDialers: any = []
  selectedOption: any = 'keydata';
  getAuto: any = []
  automationchangevalue: any;
  selfData: number;

  constructor(protected data: LeadService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, public dialog: MatDialog) {
    super(data, router, fb, msg);
    this.keydata = parseInt(sessionStorage.getItem('userid'));
    this.selfData = parseInt(sessionStorage.getItem('userid'));
    this.keytype = parseInt(sessionStorage.getItem('type'));
  }

  gInit(): void {
    this.udL = false
    this.campaignsIds = [sessionStorage.getItem("currcampaign")]
    this.r1 = true
    this.r2 = false
    this.sRd = '2'
    this.isSave = false
  }

  ngOnInit(): void {
console.log("CampIds:::",this.CampIds)
    super.ngOnInit();
    this.data.solution.subscribe(res => {
      if (res != null) {
        console.log("Update data " + JSON.stringify(res));
        this.cdata = new LeadForm(res);
        this.keyfield = res.id;
        this.form = this.cdata.makeform(this.fb);
      } else {
        console.log("adding data " + JSON.stringify(res));
        this.cdata = new LeadForm(null);
        this.keyfield = -1;
        this.form = this.cdata.makeform(this.fb);
      }
    });

    // @dialer mapping
    /* if (sessionStorage.getItem("allcampaign")) {
      this.dialerlist = JSON.parse(sessionStorage.getItem("allcampaign"))
      for (let x of this.dialerlist) {
        this.CampIds.push(x.id)
        x['leadList'] = []
        x['isAct'] = false
        if (x.dialer_type == 1)
          this.rDialers.push(x.id)
      }
    } */

    this.gInit()
 console.log("this.CampIds::", this.CampIds)
    this.enCmp({id:sessionStorage.getItem("currcampaign"),checked:true});
 console.log("this.CampIds::", this.CampIds)
    // @loading the lead's scripts
    this.data.getScripts().subscribe(res => {
      console.log("res", res)
      this.leadList = res;
      console.log("this.dialerlist_1::", this.dialerlist)
    }, err => {
      this.leadList = []
      console.log("err::", err)
    })

    // @loading the lead's fields
    console.log("this.CampIds::", this.CampIds)
    this.data.GetLeadFields(this.CampIds).subscribe(res => {
      console.log("crm labels", res)
      this.leadFields = res;
    }, err => {
      this.leadFields = {}
      console.log("err::", err)
    })

    // @loading the lead's mapped header
    this.data.GetLeadHeaders("").subscribe(res => {
      console.log("res", res)
      this.mappedheader = res || []
    }, err => {
      this.mappedheader = []
      console.log("err::", err)
    })
    // @get multiple dialer's datas'

    // @loading agent's list
    this.data.getOption('leadagent').subscribe(res => {
      console.log(res)
      this.leadagentList = res || []
    }, err => {
      this.leadagentList = []
      console.log("err::", err)
    })

    // @loading state's list
    this.data.getOption('state').subscribe(res => {
      console.log(res)
      this.stateList = res || []
    }, err => {
      this.stateList = []
      console.log("err::", err)
    })

    //get Automation data
    // this.data.getAutomation("").subscribe(res=>{
    //   this.getAuto = res.result;
    //   console.log("automation",this.getAuto);
    // })

    this.data.AutomationData(JSON.stringify({automation: "" ,from_email  : "",from_number: ""})).subscribe(res => {
      this.getAuto = res.result;
      console.log("automation", this.getAuto);
    })
  }

  // @To select lead_script & agent to assign the lead
  GetScript(e: any, id_campaign: number, type: number): void {
    console.log("e::", e.value)

    // It will select lead scripts
    if (type == 1) {
      let Index: any = this.DialerScripts.findIndex((ele, i) => {
        return ele.id_dialer === id_campaign
      })
      console.log("Index::", Index)
      if (Index >= 0)
        this.DialerScripts.splice(Index, 1)
      this.DialerScripts.push({
        id_dialer: id_campaign,
        lead_type: e.value
      })
      console.log("this.DialerScripts::", this.DialerScripts)
    }

    // It will select agent to assign leads
    if (type == 2) {
      let Index: any = this.DialerAgents.findIndex((ele, i) => {
        return ele.id_dialer === id_campaign
      })
      console.log("Index::", Index)
      if (Index >= 0)
        this.DialerAgents.splice(Index, 1)
      this.DialerAgents.push({
        id_dialer: id_campaign,
        agent_type: e.value
      })
      console.log("this.DialerAgents::", this.DialerAgents)
    }
  }

  onComplete(event: any) {
    console.log("Leads uploaded::");
    console.log("event::", event)

    if (event.type == "csv" || event.type == "txt" || event.type == "xls") {
      // @Not usable this portion
      if (this.leadopt == 1) {
        this.data.saveQuickUpload(JSON.stringify({
          fileheader: event.fileheader,
          filepath: event.filepath,
          id_upload: event.id_upload,
          ddnumber: this.ddnumber
        })).subscribe(res => {
          this.msg.open(res.message, 'Clear', {
            duration: 2000,
          });
          this.data.changefrm(false);
          this.data.changelabel("List Details");
          location.reload();
        });
      }
      // @Usable portion
      else {
        this.fieldsMapping(event.fileheader, event.filepath, this.leadFields, event.id_upload);
        this.openSnackBar("Data is added successfully", "Clear");
      }
    }
    else {
      this.openSnackBar("Invalid file type.", "Clear");
    }
  }

  AddSinghLead(type: number = 0) {
    // pulling selected dialers
    this.ActDialers = []
    this.dialerlist.forEach((ele: any) => {
      this.ActDialers.push(ele.id)
    })
    let id_state: string = ""
    let leadFields: any = {}

    if (type == 1) {
      leadFields = this.finalDtSn.leadFields ? this.finalDtSn.leadFields : this.leadFields
      id_state = this.finalDtSn.id_state
    } else
      leadFields = this.leadFields

    const dialogRef = this.dialog.open(SingleleadComponent, {
      disableClose: true,
      width: '1500px',
      data: {
        leadFields: this.leadFields,
        rawFields: this.leadFields,
        id_state: id_state,
        stateList: this.stateList,
        ActDialers: this.ActDialers,
        type: type
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed')

      if (typeof result.leadFields != undefined && result.leadFields != null) {
        console.log("result::", JSON.stringify(result))
        // @enable dialer's mapping
        if (result.is_save) {
          this.finalDtSn = result
          this.isSave = true
        } else {
          this.reSetRadio()
        }
        this.isC = this.finalDtSn.isC
      } else {
        this.reSetRadio()
        this.isC = false
      }
    })
  }

  singlelead(event: any) {
    console.log(event);
    event = event.value
    this.leadopt = event;
    if (event == 1 || event == 2) {
      this.uploadtype = false;
      this.isSave = false
    }
    if (event == 3) {
      this.uploadtype = true;
      this.AddSinghLead()
    }
  }

  fieldsMapping(fielsdata: any, file: string, leadfield: any, id_upload: number) {
    // pulling selected dialers
    console.log('leadfield::::::', leadfield)
    this.ActDialers = []
    this.dialerlist.forEach((ele: any) => {
      if (ele.isAct)
        this.ActDialers.push(ele.id)
    })
    console.log("this.ActDialers::", this.ActDialers)
    let sC = window.screen.availWidth >= 1280 ? '1200px' : '900px'
    const dialogRef = this.dialog.open(MapleadfeldComponent, {
      disableClose: true,
      width: sC,
      data: {
        fileheader: fielsdata,
        filepath: file,
        leadfield: leadfield,
        maphead: this.mappedheader,
        id_upload: id_upload,
        ActDialers: this.ActDialers
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result);
      if (result != null && result != undefined) {
        // @enable dialer's mapping
        this.udL = true
        this.finalDt = result
        this.finalDt = JSON.parse(this.finalDt)
        this.isC = this.finalDt.isC
      }
    });
  }

  OnUploadDuplicateNum(events: any) {
    console.log(events);
    this.ddnumber = events.checked;
  }

  /** @New functions **/
  enCmp(e: any): void {
    if (e) {
      let id_dialer = e.id;
      console.log("id_dialer::", id_dialer)
      console.log("dialerlist",this.dialerlist)
      let Index: any =''

      if(this.dialerlist.length > 0){
       Index = this.dialerlist.findIndex((ele: any) => {
        return ele.id == id_dialer
      })
      }else{
        Index = e.id
      }
      
      console.log("Index::", Index)

      if (Index > -1) {
        if (e.checked == true) {
          this.dialerlist[Index].isAct = true
          this.campaignsIds.push(id_dialer)
          //this.showAutomation = true
        } else {
          this.dialerlist[Index].isAct = false;
          //this.showAutomation = false
          let index = this.campaignsIds.indexOf(id_dialer)
          if (index > -1) {
            this.campaignsIds.splice(index, 1);
            /* this.showAutomation =true
            if(this.campaignsIds.length<1){
              this.showAutomation = false
            }else{
              this.showAutomation = true

            } */
          }
        }
      }
      this.campaignsIds.sort()
    }
  }



  // @save-bulk leads
  svLeads(): any {
    if (this.campaignsIds.length == 0) {
      alert("Kindly select atleast 1 dialer to save the leads.")
      return false
    }

    if (this.finalDt) {
      console.log("this.finalDt::", this.finalDt)

      // Mapping lead scripts + assignee agents dialer-wise
      if (Array.isArray(this.finalDt.dialers) && this.finalDt.dialers.length > 0) {
        let dA: any[] = []
        this.finalDt.dialers.forEach((x: any, i: any) => {
          // if (x.header.length > 0) {
          x['lead_type'] = 0
          x['agent_type'] = 0

          // if(this.keytype==5)
          // {
          //   x['agent_type']=this.keydata
          // }
          // checking selected lead scripts
          let I1: any = this.DialerScripts.findIndex((ele: any) => {
            return ele.id_dialer == x.id_dialer
          })
          if (I1 > -1)
            x.lead_type = this.DialerScripts[I1].lead_type

          // checking selected agent
          let I2: any = this.DialerAgents.findIndex((ele: any) => {
            return ele.id_dialer == x.id_dialer
          })

          if (I2 > -1) {
            if (this.keytype == 4) {
              x.agent_type = this.DialerAgents[I2].agent_type
            }
            else {
              x.agent_type = this.keydata
            }
          }else{
            x.agent_type = this.keydata
          }


          // } else {
          //   dA.push(i)
          // }
        })

        // if (dA.length > 0)
        //   dA.forEach((x: any, i: any) => {
        //     if (i > 0)
        //       x--
        //     this.finalDt.dialers.splice(x, 1)
        //   })

        let sDc: any = []
        this.ActDialers.forEach((ele: any) => {
          let Index: any = this.finalDt.dialers.findIndex((ele2: any) => {
            return ele2.id_dialer == ele
          })
          if (Index > -1)
            sDc.push(this.finalDt.dialers[Index])
        })
        this.finalDt.dialers = [] = sDc
      }

      // Mapping list of total campaigns
      this.finalDt['campaigns'] = this.CampIds
      this.finalDt['rDialers'] = this.rDialers
      this.finalDt['Automation'] = this.automationchangevalue
      console.log(this.finalDt,"value of final");


      this.finalDt = JSON.stringify(this.finalDt)

      console.log("submitted::", this.finalDt)
      this.isUpload = true
      this.data.saveHeaderMapping(this.finalDt).subscribe(rs => {
        this.isUpload = false
        this.msg.open(rs.message, 'Clear', {
          duration: 2000,
        });
        this.data.changefrm(false)
        this.data.changelabel("List Details")
        location.reload()
      })
    }
  }

  // @save-single leads
  svLeadsSn(): any {
    if (this.campaignsIds.length == 0) {
      alert("Kindly select atleast 1 dialer to save the leads.")
      return false
    }

    if (typeof this.finalDtSn.leadFields != 'undefined' && this.finalDtSn.leadFields) {

      // @dialer mapping
      let Dialers: any[] = this.DialerScripts
      for (let row of Dialers) {
        let Index: any = this.DialerAgents.findIndex((x, i) => {
          return x.id_campaign === row.id_campaign
        })
        row['agent_type'] = Index > -1 ? this.DialerAgents[Index].agent_type : 0
      }

      this.finalDtSn.leadFields.Dialers.forEach((ele: any) => {
        let I: any = Dialers.findIndex((ele2: any) => {
          return ele2.id_dialer == ele.id_dialer
        })
        ele['lead_type'] = 0
        ele['agent_type'] = this.keydata
        if (I > -1) {
          ele.lead_type = Dialers[I].lead_type
          if (this.keytype == 4) {
            ele.agent_type = this.DialerAgents.length > 0 ? this.DialerAgents[I].agent_type : this.keydata
          }
          else {
            ele.agent_type = this.keydata
          }
        }
      })

      let leadData: any = {}
      leadData = this.finalDtSn.leadFields

      // It will remove extra fields from json
      // to filter raw fields
      let nR: any[] = []
      leadData.RawHeader.forEach((ele: any) => {
        let oC: any = Object.entries(ele)[Object.entries(ele).length - 1],
          oN: any = Object.create({})

        oN[oC[0]] = oC[1]
        nR.push(oN)
      })
      leadData.RawHeader = nR

      // to filter dialer-wise fields
      leadData.Dialers.forEach((ele: any) => {
        let nR: any[] = []
        ele.header.forEach((ele2: any) => {
          let oC: any = Object.entries(ele2)[Object.entries(ele2).length - 1],
            oN: any = Object.create({})

          oN[oC[0]] = oC[1]
          nR.push(oN)
        })
        ele.header = nR
      })

      let sDt: any = JSON.stringify({
        leadData: leadData,
        id_state: this.finalDtSn.id_state,
        campaigns: this.campaignsIds,
        rDialers: this.rDialers,
        automation:this.automationchangevalue
      })
      console.log("submitted::", sDt)
      console.log("this.finalDtSn.leadFields::", JSON.stringify(this.finalDtSn.leadFields))

      this.isUpload = true
      this.data.saveSingleLead(sDt).subscribe(res => {
        console.log(res)
        this.isUpload = false
        this.openSnackBar(res.message, "Clear")
        this.data.changefrm(false)
        this.data.changelabel("List Details")
        location.reload()
      })
    }
  }

  // It will reset selected dialer to upload the lead
  reEvent(): void {
    console.log("Upload reset::")
    this.campaignsIds = []
    this.isC = false
    this.chkD = false
    this.finalDt = {}
    this.finalDtSn = {
      leadFields: ""
    }
    this.reSetRadio()
    for (let x of this.dialerlist) {
      x.isAct = false
    }
  }

  reSetRadio(): void {
    // @reset radios
    this.sRd = "2"
    this.uploadtype = false

    // reset at bulk lead uploads
    this.singlelead({
      value: 2
    })
  }

  automationchange(event:any){
    console.log(event.value,"event");
    this.automationchangevalue=event.value;
  }

}
